module.exports = __webpack_public_path__ + "img/society-ng-mui-avatar.d0160c63.png";